module.exports = __webpack_public_path__ + "img/insular.e1eba1b2.png";